import React, { useState, useRef, useEffect} from 'react';
import {firestore} from './firebaseConfig';
import { useSessionReactions, useSessionColors } from './reusableHooks';
import { ComposedChart, Bar, LineChart, RadarChart, PolarGrid, Line, Radar, XAxis, YAxis, PolarAngleAxis, PolarRadiusAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const map = {};
const useData = (sessionId, type, sessionReactions) => {
  const [data,setData] = useState([]);
  useEffect(() => {
    if(type === "interval-line" || type === "interval-bar") {
     const unsubscribe = firestore
          .collection("meetings/" + sessionId + "/voteHistory").orderBy("time")
          .onSnapshot((snapshot) => {
              const newData = snapshot.docs.map((doc, index) => {
                map[index] = doc.data().time.toDate().toLocaleTimeString(); 
                return {
                ...doc.data(), 
                time: doc.data().time.toDate().toLocaleTimeString(),
                index: index,
                }
              })
              setData(newData);
          })
        
      return () => unsubscribe();   
    } 
    else if(type === "accumulated-line" || type === "accumulated-bar") {
      const unsubscribe = firestore
      .collection("meetings/" + sessionId + "/voteCountHistory").orderBy("time")
      .onSnapshot((snapshot) => {
          const newData = snapshot.docs.map((doc, index) => {
            map[index] = doc.data().time.toDate().toLocaleTimeString(); 
            return {
            ...doc.data(), 
            time: doc.data().time.toDate().toLocaleTimeString(),
            index: index,
            }
          })
          setData(newData);
      })
    
      return () => unsubscribe();   
    }
    else if(type === "radial") {
      /*const unsubscribe = firestore
      .collection("meetings/" + sessionId + "/voteCountHistory").orderBy("time")
      .onSnapshot((snapshot) => {
          const newData = snapshot.docs.map((doc) => {
            const obj = doc.data();
            const time = doc.data()["time"];
            delete obj["time"];

            const arr = []; 
            sessionReactions.forEach((reaction) => {
              arr.push({reaction: reaction, count: obj[reaction], time:  doc.data().time.toDate().toLocaleTimeString()})
            })
            //console.log(arr)
            return arr
          })
          setData(newData);
      })
    
      return () => unsubscribe();   */
    }
  }, [sessionId, sessionReactions, type]) 
  return data;
}

const useRadialData = (sessionId, type, sessionReactions) => {
  const [data,setData] = useState({});
  useEffect(() => {
    if(type === "interval-radial") {
      const unsubscribe = firestore
      .collection("meetings/" + sessionId + "/voteHistory").orderBy("time")
      .onSnapshot((snapshot) => {
          const newData = {};
          
          snapshot.docs.map((doc) => {
            const obj = doc.data();
            const time = doc.data()["time"];
            delete obj["time"];

            const arr = []; 
            sessionReactions.forEach((reaction) => {
              arr.push({reaction: reaction, count: obj[reaction], time:  doc.data().time.toDate().toLocaleTimeString()})
            })
            //console.log(arr)
            newData[time.toDate().toLocaleTimeString()] = arr;
            return arr
          })
          setData(newData);
      })
    
      return () => unsubscribe();   
    }
    else if(type === "accumulated-radial") {
      const unsubscribe = firestore
      .collection("meetings/" + sessionId + "/voteCountHistory").orderBy("time")
      .onSnapshot((snapshot) => {
          const newData = {};
          
          snapshot.docs.map((doc) => {
            const obj = doc.data();
            const time = doc.data()["time"];
            delete obj["time"];

            const arr = []; 
            sessionReactions.forEach((reaction) => {
              arr.push({reaction: reaction, count: obj[reaction], time:  doc.data().time.toDate().toLocaleTimeString()})
            })
            //console.log(arr)
            newData[time.toDate().toLocaleTimeString()] = arr;
            return arr
          })
          setData(newData);
      })
    
      return () => unsubscribe(); 
    }
  }, [sessionId, sessionReactions, type]) 
  return data;
}

const useTimes = (sessionId, type, sessionReactions) => {
  const [times,setTimes] = useState([]);

  useEffect(() => {
    if(type ==="interval-radial"){
     const unsubscribe = firestore
          .collection("meetings/" + sessionId + "/voteHistory").orderBy("time")
          .onSnapshot((snapshot) => {
              const newTimes = snapshot.docs.map((doc, index) => {
                return doc.data().time.toDate().toLocaleTimeString()
              })
              setTimes(newTimes);
          })
        
      return () => unsubscribe();  
    } 
    else if(type ==="accumulated-radial"){
      const unsubscribe = firestore
           .collection("meetings/" + sessionId + "/voteCountHistory").orderBy("time")
           .onSnapshot((snapshot) => {
               const newTimes = snapshot.docs.map((doc, index) => {
                 return doc.data().time.toDate().toLocaleTimeString()
               })
               setTimes(newTimes);
           })
         
       return () => unsubscribe();  
     } 
  }, [sessionId, sessionReactions, type]) 

  return times;
}

const getAxisYDomain = (from, to, ref, offset, data) => {
  const refData = data.slice(from - 1, to);

  let [bottom, top] = [refData[0][ref], refData[0][ref]];
  refData.forEach((d) => {
    if (d[ref] > top) top = d[ref];
    if (d[ref] < bottom) bottom = d[ref];
  });

  return [(bottom | 0) - offset, (top | 0) + offset];
};

export default function TimeSeries({sessionId, type}) {
    const sessionReactions = useSessionReactions(sessionId, false);
    const data = useData(sessionId, type, sessionReactions);
    const radialData = useRadialData(sessionId, type, sessionReactions);
    const times = useTimes(sessionId, type, sessionReactions);
    const [selectedTime, selectTime] = useState(null);

    //if(sessionId) voteCountHistory(sessionId).then((res) => console.log(res));
    //const barColors = ["#E41A1C", "#FF7F00", "#377EB8", "#984EA3", "#4DAF4A", "#404142"];
    const barColors = useSessionColors(sessionId, false);
    
    const COLORS = {};
    sessionReactions?.map((reaction, index) => {
        COLORS[reaction] = barColors[index % barColors.length];
    })

    const initialState = {
      data: data,
      left: 'dataMin',
      right: 'dataMax',
      refAreaLeft: '',
      refAreaRight: '',
      top: 'dataMax+1',
      bottom: 'dataMin-1',
      top2: 'dataMax+20',
      bottom2: 'dataMin-20',
      animation: true,
    };

    const [pan, setPan] = useState(initialState);
    const zoom = () => {
      let refAreaLeft = pan.refAreaLeft;
      let refAreaRight =  pan.refAreaRight;

      if (refAreaLeft === refAreaRight || refAreaRight === '' || refAreaLeft === '') {
          const myState = {
              ...initialState,
              refAreaLeft: '',
              refAreaRight: ''
            };
          setPan(myState);
        return;
      }
  
      // xAxis domain
      if (refAreaLeft > refAreaRight) [refAreaLeft, refAreaRight] = [refAreaRight, refAreaLeft];
  
      // yAxis domain
      const [bottom, top] = getAxisYDomain(refAreaLeft, refAreaRight, 'index', 1, data);
      const [bottom2, top2] = getAxisYDomain(refAreaLeft, refAreaRight, 'index', 50, data);
  
      setPan({
        refAreaLeft: '',
        refAreaRight: '',
        data: data.slice(),
        left: refAreaLeft,
        right: refAreaRight,
        bottom: bottom,
        top: top,
        bottom2: bottom2,
        top2: top2,
      });
    }

    useEffect(() => {
      if(times.length > 0) selectTime(times[times.length - 1]);
    }, [times])

    return (
      <>
        <div className="stats pb-3 pl-3 pt-2">
          { (type==="interval-line" || type==="accumulated-line") && <Timeline data={data} pan={pan} setPan={setPan} zoom={zoom} sessionReactions={sessionReactions} COLORS={COLORS}/>}
          { (type==="interval-bar" || type==="accumulated-bar") && <BarTimeseries data={data} pan={pan} setPan={setPan} zoom={zoom} sessionReactions={sessionReactions} COLORS={COLORS}/>}
          {/* (type==="interval-radial" || type==="accumulated-radial") && 
            <div className="d-flex flex-column" id="AnimatedTimeSeries" key="AnimatedTimeSeries">
              <AnimatedTimeSeries data={radialData} time={selectedTime}/> 
              <TimeBar selectedTime={selectedTime} times={times} selectTime={selectTime}/>
            </div>
          */}
      </div>
      </>
    )
}

function Timeline({data, pan, setPan, zoom, sessionReactions, COLORS}) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
      width="100%"
      height="100%"
      data={data}
      margin={{
        top: 5,
        right: 0,
        left: -35,
        bottom: 5,
      }}
      onMouseDown={(e) => e && setPan({ ...pan, refAreaLeft: e.activeLabel })}
      onMouseMove={(e) => e && pan.refAreaLeft && setPan({ ...pan, refAreaRight: e.activeLabel })}
      onMouseUp={zoom}
    >
      <XAxis allowDataOverflow dataKey="index" domain={[pan.left, pan.right]} type="number" 
          tickFormatter={(index) => (map[index]? map[index] : "")}
      />
      <YAxis allowDecimals={false}/>
      <Tooltip isAnimationActive={false} wrapperStyle={{ width: "auto", height: "auto"}} labelFormatter={(index) => (map[index])}/>
      <Legend />

      {sessionReactions?.map((entry, index) => {
      return <Line isAnimationActive={false} type="monotone" dataKey={entry} stroke={COLORS[entry]} strokeWidth={2} dot={false} activeDot={{ r: 8 }} />
      })}
    </LineChart>
  </ResponsiveContainer>
  )
}

function BarTimeseries({data, pan, setPan, zoom, sessionReactions, COLORS}) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart width="100%" height="100%" data={data} barSize={100}
        margin={{
            top: 5,
            right: 0,
            left: -35,
            bottom: 5,
        }}
        onMouseDown={(e) => e && setPan({ ...pan, refAreaLeft: e.activeLabel })}
        onMouseMove={(e) => e && pan.refAreaLeft && setPan({ ...pan, refAreaRight: e.activeLabel })}
        onMouseUp={zoom}
        >
        <XAxis allowDataOverflow dataKey="index" domain={[pan.left, pan.right]} type="number" 
            tickFormatter={(index) => (map[index])}
        />
        <YAxis/>
        <Tooltip isAnimationActive={false} wrapperStyle={{ width: "auto", height: "auto"}} labelFormatter={(index) => (map[index])}/>
        <Legend />
        {sessionReactions?.map((entry, index) => (
            <Bar isAnimationActive={false} dataKey={entry} stackId="a" fill={COLORS[entry]}/>
        ))}
        {/*<Brush  dataKey="time"/>*/}
    </ComposedChart>
  </ResponsiveContainer>
  )
}

function AnimatedTimeSeries({data, time}) {
  console.log(data[time])
  return (
    <>
    <ResponsiveContainer className="radial-graph" width="100%" height="90%">
      <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data[time]}>
        <PolarGrid />
        <PolarAngleAxis dataKey="reaction"/>
        {<PolarRadiusAxis />}
        <Radar name="Reactions" dataKey="count" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
      </RadarChart>
    </ResponsiveContainer>
    </>
  )
}

//get array of time and display them
function TimeBar({selectedTime, times, selectTime}) {
 //console.log(times)
 const [scrollLeft, setScroll] = useState(0);
 const [scrollSize, setScrollSize] = useState(0);
 const elementSize = document.getElementsByClassName("selected-time")[0]?.offsetWidth;
 const elements = useRef([]);

  useEffect(() => {
        //need to fix calculation
        const toSelect = Math.floor(scrollLeft / ((scrollSize - 500) / elements.current.length));
        //console.log(toSelect);
        //console.log("Selecting ... " + elements.current[toSelect].id);
        if(elements.current[toSelect]) selectTime(elements.current[toSelect].id);
        //console.log("Currently selected: " + selectedTime)
  }, [scrollLeft])

  const handleScroll = (e) => {
    setScroll(e.target.scrollLeft);
    setScrollSize(e.target.scrollWidth);
  }
  return (
    <div className="no-wrap time-scroll" onScroll={handleScroll}>
        {times.map((entry, index) => {
          const color = selectedTime === entry? "text-success" : "text-white"
          if(selectedTime === entry) return <p className={"d-inline mx-1 h-auto selected-time"} id={entry} 
            onClick={(e) => (selectTime(e.target.id))}
            ref = {el => elements.current[index] = el}
          >{entry.substring(0,4)}</p>
          else return <p className={"d-inline mx-1 h-auto"} id={entry} 
          onClick={(e) => (selectTime(e.target.id))}
          ref = {el => elements.current[index] = el}
        >{entry.substring(0,4)}</p>
        })}
    </div>
  )
}